module.exports = __webpack_public_path__ + "static/profile-d34d827da099cb68ac3ed04a6e125cee.jpg";